import RadioAntD from 'antd/lib/radio';
import React from 'react';
import { connectField, filterDOMProps } from 'uniforms';
import wrapField from './wrapField';

var Radio = function Radio(props) {
  return wrapField(props, React.createElement(RadioAntD.Group, Object.assign({
    disabled: props.disabled,
    name: props.name,
    onChange: function onChange(event) {
      return props.onChange(event.target.value);
    },
    value: props.value
  }, filterDOMProps(props)), props.allowedValues.map(function (value) {
    return React.createElement(RadioAntD, {
      key: value,
      value: value,
      style: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      }
    }, props.transform ? props.transform(value) : value);
  })));
};

export default connectField(Radio);